import React from 'react';

export default function SATextArea(props) {
    const register = props?.register;
    return (
        <React.Fragment>
            <div className="form-group">
                <label htmlFor={props?.htmlFor}>{props.label}
                    { 
                        props.isStrong ?
                            <strong className="text-primary">*</strong>
                            : null
                    }
                </label>
                <textarea
                    {...register(props?.name, props.requiredObj)}
                    name={props?.name} id={props?.name}
                    className="form-control" placeholder={props.placeholder} maxLength={props.maxLength}></textarea>
                <small id={props.id} className="text-primary">
                    {props?.errMsg}
                </small>
            </div>
        </React.Fragment>
    )
}
